import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import React from "react";
import { faEnvelope, faPhone, faShareNodes, faAdd, faStar } from '@fortawesome/free-solid-svg-icons'
const myIcon = {
    phone:faPhone,
    envelope: faEnvelope,
    share: faShareNodes,
    add: faAdd,
    star: faStar
}

export default function RoundButton({icon, name, clickEvent, disabled}) {

    return (
        <div className={'flex flex-col justify-center items-center cursor-pointer'} onClick={clickEvent}>
            <div className={'flex rounded-full self-center h-12 w-12 border-2 border-solid border-[#DDDDDD] items-center justify-center'}>
                <FontAwesomeIcon className={disabled ? 'text-gray-300' : 'text-[#18B8BF]'} icon={myIcon[icon]}/>
            </div>
            <span className={disabled ? 'text-sm mt-1 text-gray-300' : 'text-sm mt-1'}>{name}</span>
        </div>
    )
}
